import { render, staticRenderFns } from "./DisplayValueField.vue?vue&type=template&id=3ae38955&scoped=true"
import script from "./DisplayValueField.vue?vue&type=script&lang=ts"
export * from "./DisplayValueField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae38955",
  null
  
)

export default component.exports